import React, { FC } from 'react'
import { HistoryOrderStatusString, IHistorySectionOrder } from '../../../../models/order/aggregates/history/IOrderHistory'
import "./OldOrderList.css"
import { PaymentTypeString } from '../../../../models/payment/IPay'
import Utils from 'utils/utils'
import { useI18n } from 'utils/i18n/hooks/useI18n';
import { ICurrency } from 'models/local/ILocalConfig'
interface OldOrderListProps {
    orders: IHistorySectionOrder
}
const OldOrderList: FC<OldOrderListProps> = ({ orders }) => {
    const { t } = useI18n();
    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    return (
        <div id="oldOrderList">
            <div className="container-oldOrderList">
                <div className="date-oldOrderList">
                    {Utils.toDate(orders.date, true)}
                </div>
                <div className="orders-oldOrderList">
                    {orders.orders.map((order,index) =>
                        (
                            <div key={`${order.id || index}-${order.historyStore.name}`} className="order-oldOrderList">
                                <div className="top-order-oldOrderList">
                                    <div className="estabelecimento-order-oldOrderList">
                                        {order.historyStore.name}
                                    </div>
                                    <div className="date-order-oldOrderList">
                                        {Utils.toTime(order.createdAt, true)}
                                    </div>
                                </div>
                                <div className="status-order-oldOrderList">
                                    {HistoryOrderStatusString(order.status)}
                                </div>
                                <div className="content-order-oldOrderList">
                                    {t("orders.labels.order")}
                                    <div className="orderItens-order-oldOrderList">
                                        {order.historyOrderItems.map((orderItem, itemIndex) => (
                                            <div key={`${orderItem.name}-${itemIndex}`} className="orderItem-order-oldOrderList">
                                                <div className="text-orderItem-oldOrderList">
                                                    {orderItem.quantity}x {orderItem.name}
                                                </div>
                                                <div className="value-orderItem-oldOrderList">
                                                    {currency?.symbol ?? "R$"} {orderItem.value.toFixed(2).replace(".", ",")}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="footer-order-oldOrderList">
                                    {
                                        !!order.historyPayment.length &&
                                        <div className="id-order-oldOrderList">
                                            {t("orders.labels.payment")}
                                        {order.historyPayment.map((payment) => (PaymentTypeString(payment.type) + " "))}
                                        </div>
                                    }
                                    <div className="id-order-oldOrderList">
                                        {t("orders.labels.total")}
                                        {currency?.symbol ?? "R$"} {order.amount.toFixed(2).replace(".", ",")}
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

export default OldOrderList
